import React, { Component } from 'react';
import AppConfig from './config';
import MovieManager from './views/movie-manager/movie-manager';


class App extends Component {

  constructor() {
    super();

    // NOTE: lot the app info for QA & validation
    console.log(JSON.stringify({ ...AppConfig.appInfo, env: AppConfig.env }, null, 2));
  }

  render() {
    return (
      <div className="app">
        <MovieManager />
      </div>
    );
  }
}

export default App;
